import React from "react";

const SubmitButton = ({ title = "Submit", isDisabled = false, className = "button", submitting = false, ...other }) => {
  if (submitting) {
    return (
      <button className={`${className} btn__icon__container`}>
        <div className="loading-state">
          <div className="loading"></div>
        </div>
      </button>
    );
  }

  return (
    <button
      type="submit"
      className={`${className} ${isDisabled ? "button--disabled" : ""}`}
      disabled={isDisabled}
      {...other}
    >
      {title}
    </button>
  );
};

export default SubmitButton;
